import * as types from '../actions/types';

const initialState = {
   toggler:false
}

export default function SidebarRewardReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.REWARD_TOGLE_SIDEBAR:
            return {
                
                toggler:action.payload,
            } 
        default:
            return state
    }
}
